import styled from 'styled-components';

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 16px;
  width: 100%;
  gap: 16px;
  border-radius: 8px;

  box-shadow: ${({ isMultiAccount }) =>
    !isMultiAccount ? '0px 2px 4px 0px rgba(14, 20, 29, 0.15)' : 'none'};

  > div:nth-child(1) {
    max-width: 278px;
    height: 24px;
  }

  @media (min-width: 769px) {
    > div:nth-child(1) {
      max-width: 100%;
      height: 24px;
    }
  }
`;

const SkeletonContainerInfoStyled = styled.div`
  display: grid;
  grid-template-columns: auto;
  width: 100%;
  gap: 8px;

  @media (min-width: 769px) {
    grid-template-columns: 70% 30%;
  }
`;

const SkeletonContainerInfoCombinedStyled = styled.div`
  display: flex;
`;

const SkeletonContainerInfoLeftStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  > span:nth-child(1) {
    max-width: 136px;
    height: 14px !important;
    border-radius: 8px;
  }
  > span:nth-child(2) {
    max-width: 111px;
    height: 29px !important;
    border-radius: 8px;
  }
`;

const SkeletonContainerInfoRightStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
  width: 100%;

  > span:nth-child(1) {
    max-width: 65px;
    height: 14px !important;
    border-radius: 8px;
  }
  > span:nth-child(2) {
    max-width: 105px;
    height: 27px !important;
    border-radius: 8px;
  }
`;

const SkeletonContainerInfoTwoStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 16px;

  > span {
    max-width: 100%;
    height: 44px !important;
    border-radius: 8px;
  }
`;

const SkeletonContainerInfoThreeStyled = styled.div`
  display: ${({ isMultiAccount }) => (isMultiAccount ? 'none' : 'flex')};
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: center;

  > span:nth-child(1) {
    max-width: 183px;
    height: 18px !important;
    border-radius: 8px;
  }
  > span:nth-child(2) {
    max-width: 240px;
    height: 18px !important;
    border-radius: 8px;
  }

  @media (min-width: 769px) {
    border-top: 1px solid #c9cfd7;
    grid-column: 1 / -1;
    margin-left: -16px;
    width: calc(100% + 24px);

    > span:nth-child(1) {
      max-width: 392px;
      height: 24px !important;
      border-radius: 8px;
      margin-top: 10px;
    }
    > span:nth-child(2) {
      display: none;
    }
  }
`;

const SkeletonTitle = styled.div`
  height: 24px;
  span {
    border-radius: 8px;
  }
`;
const SkeletonMultiAccountBottomStyled = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-top: 1px solid #c9cfd7;
  padding-top: 10px;
  padding-bottom: 12px;
  grid-column: 1 / 3;
`;

const SkeletonBottomMultiAccountStyled = styled.div`
  max-width: 249px;
  height: 18px;
  margin: auto;
  span {
    border-radius: 44px;
  }

  @media (min-width: 769px) {
    min-width: 392px;
    height: 24px;
  }
`;
export {
  SkeletonContainer,
  SkeletonContainerInfoStyled,
  SkeletonContainerInfoCombinedStyled,
  SkeletonContainerInfoLeftStyled,
  SkeletonContainerInfoRightStyled,
  SkeletonContainerInfoTwoStyled,
  SkeletonContainerInfoThreeStyled,
  SkeletonTitle,
  SkeletonMultiAccountBottomStyled,
  SkeletonBottomMultiAccountStyled,
};
